import React from "react"
import styles from "./index.module.scss"
import smoothscroll from 'smoothscroll-polyfill'
import defaultSetting from '@/setting'
import { isMobile } from '@/utils/util'
import { mechanisList } from "./constants"
import MechanismItem from './cmp/mechanismItem'
import MechanismPanel from './cmp/mechanismItem/panel'

class MechanismList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mechanisList,
            prevIndex: null, // 上一次选择的card
        }
    }
    componentDidMount() {
        if(!isMobile) window.location.href = `${defaultSetting.domain}`
        document.title = '中国中化招聘微官网'
        smoothscroll.polyfill()
    }
    doSelect = (index) => {
        const prevIndex = this.state.prevIndex
        const listHeight = document.querySelectorAll('.mechanism-list')[0].clientHeight
        document.querySelectorAll('.mechanism-list li').forEach((item,idx) => {
            if(index === idx) {
                const node = item.children[1]
                if(node.getAttribute("class").indexOf('show') > -1) {
                    node.classList.add('hide')
                    node.classList.remove('show')
                    node.style.height = `0px`
                } else {
                    node.classList.add('show')
                    node.classList.remove('hide')
                    const panelHeight = node.children[0].clientHeight
                    node.style.height = `${panelHeight}px`
                    setTimeout(() => {
                        let defaultScroll = 0
                        const clientHeight = document.body.clientHeight
                        const offsetTop = node.offsetTop
                        const pageTop = node.getBoundingClientRect().top
                        // && offsetTop > clientHeight
                        if(pageTop < 300 ) {
                            defaultScroll = prevIndex === null? (offsetTop - clientHeight/2) : prevIndex < index? (offsetTop - clientHeight/2) - panelHeight : (offsetTop - clientHeight/2)
                            setTimeout(() => {
                                window.scrollTo({
                                    top: defaultScroll,
                                    behavior: "smooth"
                                });
                            }, 200)
                            // && (listHeight - offsetTop) > clientHeight
                        } else if ((pageTop + panelHeight) > clientHeight ) {
                            defaultScroll = prevIndex === null || prevIndex > index? (offsetTop - clientHeight/2) : (offsetTop - clientHeight/2) - panelHeight 
                            setTimeout(() => {
                                window.scrollTo({
                                    top: defaultScroll,
                                    behavior: "smooth"
                                });
                            }, 200)

                        } else if (listHeight === offsetTop) {
                            setTimeout(() => {
                                window.scrollTo({
                                    top: offsetTop + panelHeight,
                                    behavior: "smooth"
                                });
                            }, 200)
                        }
                        this.setState({
                            prevIndex: index
                        })
                    })
                }
                
            } else {
                const nodev = item.children[1]
                nodev.classList.add('hide')
                nodev.classList.remove('show')
                nodev.style.height = `0px`
            }
        })
        this.setState({
            mechanisList: this.state.mechanisList
        })
    }

    render() {
        return (
            <main className={`lx-container-mobile ${styles.mechanismList}`}>
                <ul className="mechanism-list">
                    {
                        this.state.mechanisList.map((item, index) => {
                            return (
                                <li className="lx-mt12" key={index} onClick={() => this.doSelect(index)}>
                                    <MechanismItem item={ item }></MechanismItem>
                                    <div className={`panel-wrap hide`}>
                                        <MechanismPanel item={ item }></MechanismPanel>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </main>
        )
    }
}

export default MechanismList